
// https://github.com/medialize/ally.js/issues/21
export default {
  element: 'div',
  mutate: function(element) {
    element.setAttribute('style', 'width: 100px; height: 50px;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  },
};



// WEBPACK FOOTER //
// ./node_modules/ally.js/src/supports/focus-scroll-container-without-overflow.js